import {
  companyHasSinglePermission,
  userHasAnyPermission,
  userHasSinglePermission,
} from 'util/PermissionsUtils';
import { Permission, Permission as P } from 'common/models/Permissions';

export const AllowCandidatesModule = () =>
  userHasSinglePermission(P.Candidates) && companyHasSinglePermission(P.Candidates);
export const AllowCandidatesAddEdit = () =>
  userHasSinglePermission(P.CandidatesAddEdit) && companyHasSinglePermission(P.CandidatesAddEdit);
export const AllowCandidatesDelete = () =>
  userHasSinglePermission(P.CandidatesDelete) && companyHasSinglePermission(P.CandidatesDelete);
export const AllowCandidatesReportsAccess = () => userHasSinglePermission(P.CandidatesReports);
export const AllowCandidatesImport = () =>
  userHasAnyPermission([Permission.OfficeAdministrator, Permission.SystemAdministrator]);
